import React, { useEffect, useState } from 'react';
import { getImagePath, onImageError } from '../../Utils/AssetUtil';
import { sortBasedOnName } from '../../Utils/Utils';

const AssetsSection = (props) => {
	const [selectedGroup, setSelectedGroup] = useState();
	const [assetList, setAssetList] = useState();

	useEffect(() => {
		let assets = props.displayItemList && [...props.displayItemList];
		if (selectedGroup && props.tabName === 'graphic') {
			assets =
				assets &&
				assets.filter((asset) => {
					return asset.groupCode === selectedGroup;
				});
				sortBasedOnName(assets, 'assetName')
			setAssetList(assets);
		} else if (props.tabName === 'schoolAsset') {
			sortBasedOnName(assets, 'assetName')
			setAssetList(assets);
		}
	}, [props.displayItemList, selectedGroup, props.tabName]);

	useEffect(() => {
		if (props.selectedId) {
			let group =
				props.displayItemList &&
				props.displayItemList.find((asset) => {
					return asset.assetId === props.selectedId;
				});
			let groupCode =
				(group && group.groupCode) ||
				(props.assetGroupList &&
					props.assetGroupList[0] &&
					props.assetGroupList[0].groupCode);
			setSelectedGroup(groupCode || '');
		} else {
			setSelectedGroup(
					(props.assetGroupList &&
						props.assetGroupList[0] &&
						props.assetGroupList[0].groupCode) ||
					''
			);
		}
	}, [props.selectedId, props.assetGroupList, props.tabName]);

	const onOptionSelect = (item) => {
		let assetGroup =
			(props.assetGroupList &&
				props.assetGroupList.find((asset) => {
					return asset.groupCode === item.groupCode;
				})) ||
			{};
		let upchargeAmt = (assetGroup && assetGroup.upchargeAmt) || 0;
		// For upper-left and upper-right zones, use sm-suffixed images; otherwise use lg
		const isUpperZone = props.zoneCode === 'upper-left' || props.zoneCode === 'upper-right';
		const imageSize = isUpperZone ? 'sm' : 'lg';
		let url = getImagePath(
			item,
			props.threadWebColor && props.threadWebColor.threadWebColor,
			imageSize
		);
		url = url.replace(process.env.REACT_APP_JOSTENS_CDN_HOST, '');
		let data = {
			decorType: 'graphic',
			assetId: item.assetId,
			assetName: item.assetName,
			groupCode: item.groupCode,
			upchargeAmt: upchargeAmt,
			licensedFlag: item.licensedFlag,
			patchFlag: item.patchFlag || 'n',
			textLines: [],
			font:'',
			pulseFont: '',
			designImageUrl: url,
		};
		props.updateZoneDetails(data);
	};

	return (
		<>
			<label className='title_div text-title' htmlFor="selectDropdown">{props.title}</label>
			{props.tabName === 'graphic' && props.assetGroupList && (
				<select
					className='selectDropdown'
					id='selectDropdown'
					onChange={(event) => {
						setSelectedGroup(event.target.value);
					}}
					value={selectedGroup}>
					{props.assetGroupList.map((obj, index) => (
						<option value={obj.groupCode} key={index}>
							{obj.groupName}
							{obj.upchargeAmt ? ' - Add for $' + obj.upchargeAmt : ''}
						</option>
					))}
				</select>
			)}
			<div className={`${(assetList && assetList.length > 0) ? 'branding_div' :'branding_div_schoolassets_tab'}`}>
				{assetList && assetList.length > 0 ? (
					assetList.map((item, index) => (
						<div
							className={`item_wraper_div`}
							onClick={() => onOptionSelect(item)}
							key={index}>
							<div className='image_div'>
								<img
									id={item.assetId}
									className={`items_div asset_image ${
										item.assetId === props.selectedId
											? 'selected_color_div'
											: ''
									}`}
									src={getImagePath(
										item,
										props.threadWebColor && props.threadWebColor.threadWebColor
									)}
									onError={(e) => {
										onImageError(e, item, props.threadWebColor, props.stoleMeta);
									}}
									alt={item.assetName + " logo"}
								/>
								{item.assetId === props.selectedId ? (
									<div className='select_icon'>
										<i className='tick'></i>
									</div>
								) : (
									''
								)}
							</div>
							<p className='color_name'>{item.assetName}</p>
						</div>
					))
				) : (
					<p className='emptyPageText'>
						{props.stoleMeta &&
							props.stoleMeta.fail &&
							props.stoleMeta.fail.assets}
					</p>
				)}
			</div>
		</>
	);
};

export default React.memo(AssetsSection);
